var map = {
	"./0.png": 8822,
	"./0_desc.png": 4082,
	"./0_stat.png": 3857,
	"./1.png": 6509,
	"./1_desc.png": 9532,
	"./1_stat.png": 8445,
	"./2.png": 3237,
	"./2_desc.png": 2518,
	"./2_stat.png": 858,
	"./3.png": 7867,
	"./3_desc.png": 7258,
	"./3_stat.png": 6626,
	"./4.png": 5685,
	"./4_desc.png": 3145,
	"./4_stat.png": 2942,
	"./5.png": 976,
	"./5_desc.png": 1410,
	"./5_stat.png": 3471,
	"./6.png": 4450,
	"./6_desc.png": 1818,
	"./6_stat.png": 3708,
	"./7.png": 368,
	"./7_desc.png": 5900,
	"./7_stat.png": 1594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2320;